import Swiper from 'swiper';
import { Autoplay, FreeMode} from 'swiper/modules';

const footerSwiper = new Swiper('.is-style-footer-top',{
  modules: [Autoplay, FreeMode],
  spaceBetween: 48,
  slidesPerView: "auto",
  loop: true,
  speed: 10000,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
    reverseDirection: true,
  },
  freeMode: true,
  breakpoints: {
    1250: {
      loop: false,
      slidesPerView: 4,
      speed: 0,
      autoplay: false,
      loopAdditionalSlides: 0,
      loopedSlides: 4,
      spaceBetween: 0
    },
  },
});

footerSwiper.update()
